module.exports = __webpack_public_path__ + "image-3491e3f6299e.png";